<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <cm-navbar :title="$ml.get('saleOrder')">
                    <f7-nav-right><f7-link @click="refresh"><i class="f7-icons">refresh</i></f7-link></f7-nav-right>
                </cm-navbar>

                <!-- FORM ADD NEW SO -->
                <f7-block-title>{{ $ml.get('addNewSaleOrder') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('customer')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="customer_id" v-model="formSo.customer_id">
                            <option v-for="item in customers" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="date" :label="$ml.get('expectedExport')" :value="formSo.estimated_at" @input="formSo.estimated_at = $event.target.value"></f7-list-input>
                    <f7-list-input type="text" :label="$ml.get('soVehicle')" clear-button :value="formSo.vehicle" @input="formSo.vehicle = $event.target.value"></f7-list-input>
                    <f7-list-input type="text" :label="$ml.get('exportReason')" clear-button :value="formSo.export_reason" @input="formSo.export_reason = $event.target.value"></f7-list-input>
                    <f7-list-input type="text" :label="$ml.get('recipientName')" clear-button :value="formSo.recipient_name" @input="formSo.recipient_name = $event.target.value"></f7-list-input>

                    <!-- <f7-list-item>
                        <span>{{ $ml.get('retailCustomer') }}</span>
                        <f7-toggle @change="formSo.is_exception = $event.target.checked"></f7-toggle>
                    </f7-list-item> -->
                    <f7-list-input type="text" :label="$ml.get('shipping_unit')" clear-button :value="formSo.shipping_unit" @input="formSo.shipping_unit = $event.target.value"></f7-list-input>
                    <f7-list-input type="number" label="VAT (%)" placeholder="0" clear-button :value="formSo.vat" @input="formSo.vat = $event.target.value"></f7-list-input>

                    <f7-list-item :title="$ml.get('retailCustomer')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="customer_id" v-model="formSo.is_exception">
                            <option v-for="(item, index) in $constant.customerTypes" :value="item.id" :key="index">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('samecont')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="samecont" v-model="formSo.samecont">
                            <option v-for="(item, index) in sosAvailable" :value="item.id" :key="index">{{ item.customer.name }} ({{ item.estimated_at }})</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="text" :label="$ml.get('notes')" clear-button :value="formSo.notes" @input="formSo.notes = $event.target.value"></f7-list-input>
                    <f7-list-input type="text" :label="$ml.get('company_name')" clear-button :value="formSo.company_name" @input="formSo.company_name = $event.target.value"></f7-list-input>

                    <f7-list-item>
                        <span>{{ $ml.get('for_internal') }}</span>
                        <f7-toggle @change="formSo.for_internal = $event.target.checked"></f7-toggle>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('addCustomer')" @click="addCustomer">
                        <i class="f7-icons" slot="media">add</i>
                    </f7-list-item>
                    <f7-list-item :title="$ml.get('documents')">
                        <input type="file" ref="fileupload" multiple v-on:change="fileChange($event.target.files)" />
                    </f7-list-item>
                </f7-list>
                <f7-block>
                    <f7-row>
                        <f7-col></f7-col>
                        <f7-col></f7-col>
                        <f7-col><f7-button fill round @click="submitSo">{{ $ml.get('save') }}</f7-button></f7-col>
                    </f7-row>
                </f7-block>
                <!-- END FORM ADD NEW SO -->

                <!-- LIST SO -->
                <div v-for="item in listSos" :key="item.status" v-show="item.data.length > 0">
                    <f7-block-title>{{ item.name }}</f7-block-title>
                    <f7-list media-list sortable @sortable:sort="onSort" sortable-enabled>
                        <f7-list-item v-for="(so, index) in item.data" :key="index" :id="so.id" :class="'list_sos'"
                            @click="showPopup(so)"
                            :title="so.customer.name"
                            :after="so.created_at"
                            :subtitle="$ml.get('expectedExport') + ': ' + so.estimated_at"
                        ></f7-list-item>
                    </f7-list>
                </div>
                <!-- END LIST SO -->


                <!-- POPUP -->
                <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
                    <f7-view>
                        <f7-page>
                            <f7-navbar :title="activeSo ? activeSo.customer.name : ''">
                                <f7-nav-right><f7-link popup-close>{{ $ml.get('close') }}</f7-link></f7-nav-right>
                            </f7-navbar>

                            <f7-list inline-labels no-hairlines-md>
                                <f7-list-input type="text" :label="$ml.get('soVehicle')" clear-button :value="activeSo ? activeSo.vehicle : ''" @input="activeSo.vehicle = $event.target.value" name="vehicle"></f7-list-input>
                                <f7-list-input type="text" :label="$ml.get('exportReason')" clear-button :value="activeSo ? activeSo.export_reason : ''" @input="activeSo.export_reason = $event.target.value" name="export_reason"></f7-list-input>
                                <f7-list-input type="text" :label="$ml.get('recipientName')" clear-button :value="activeSo ? activeSo.recipient_name : ''" @input="activeSo.recipient_name = $event.target.value" name="recipient_name"></f7-list-input>
                                <f7-list-input type="text" :label="$ml.get('shipping_unit')" clear-button :value="activeSo ? activeSo.shipping_unit : ''" @input="activeSo.shipping_unit = $event.target.value" name="shipping_unit"></f7-list-input>
                                <f7-list-input type="number" label="VAT (%)" placeholder="0" clear-button :value="activeSo ? activeSo.vat : ''" @input="activeSo.vat = $event.target.value" name="vat"></f7-list-input>
                                <f7-list-input type="text" :label="$ml.get('notes')" clear-button :value="activeSo ? activeSo.notes : ''" @input="activeSo.notes = $event.target.value"></f7-list-input>
                                <f7-list-input type="text" :label="$ml.get('company_name')" clear-button :value="activeSo ? activeSo.company_name : ''" @input="activeSo.company_name = $event.target.value"></f7-list-input>
                                <f7-list-input type="date" :label="$ml.get('expectedExport')" :value="activeSo ? activeSo.estimated_at : ''" @input="activeSo.estimated_at = $event.target.value"></f7-list-input>
                                <f7-list-item :title="$ml.get('samecont')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}" v-if="activeSo">
                                    <select name="samecont" v-model="activeSo.samecont">
                                        <option v-for="(item, index) in sosAvailable" :value="item.id" :key="index">{{ item.customer.name }} ({{ item.estimated_at }})</option>
                                    </select>
                                </f7-list-item>
                                <br>
                                <f7-row v-show="! $helper.isMobile()">
                                    <f7-col></f7-col>
                                    <f7-col>
                                        <f7-button round fill @click="downloadSo" color="orange">
                                            <i class="f7-icons" style="font-size: 24px; line-height: inherit">cloud_download</i>
                                        </f7-button>
                                    </f7-col>
                                    <f7-col></f7-col>
                                </f7-row>
                            </f7-list>

                            <div v-for="(item, index) in sodetails" :key="index">
                                <f7-block-title><f7-link @click="sodetails.splice(index, 1)"><i class="f7-icons">delete</i></f7-link></f7-block-title>

                                <f7-list inline-labels no-hairlines-md>
                                    <!-- material -->
                                    <f7-list-item :title="$ml.get('product')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}" :disabled="!item.editable">
                                        <select @change="changeMaterial(index, item.material_id)" :name="'material_id' + index" v-model="item.material_id" v-validate="'required'">
                                            <option v-for="material in materials" :value="material.id" :key="material.id">[{{ material.materialtype.name }}] {{ material.name }}{{ material.code ? ' (' + material.code + ')' : '' }}</option>
                                        </select>
                                    </f7-list-item>

                                    <!-- amount -->
                                    <f7-list-input type="number" :label="$ml.get('amount') + ' (Kg)'" placeholder="0" clear-button :value="item.amount" @input="item.amount = $event.target.value" :name="'amount' + item.id" v-validate="'required'" :disabled="activeSo && activeSo.status == $constant.so.status.proceed" @wheel.native="$event.target.blur()"></f7-list-input>

                                    <!-- packing -->
                                    <f7-list-item :title="$ml.get('packing') + ' (Kg)'" smart-select :smart-select-params="{openIn: 'sheet'}">
                                        <select :ref="'packing_select_' + index" name="packing" v-model="item.packing" v-validate="'required'">
                                            <option v-for="packing in packings" :value="packing.id" :key="packing.id">{{ packing.name }}</option>
                                        </select>
                                    </f7-list-item>

                                    <!-- price -->
                                    <f7-list-input type="number" :label="$ml.get('price') + ' (đ)'" placeholder="0" clear-button :value="item.price" @input="item.price = $event.target.value" :name="'price' + item.id" v-validate="'required'" :disabled="activeSo && activeSo.status == $constant.so.status.proceed" @wheel.native="$event.target.blur()"></f7-list-input>

                                    <!-- line color -->
                                    <f7-list-item :title="$ml.get('lineColor')" smart-select :smart-select-params="{openIn: 'sheet'}" :disabled="!item.editable">
                                        <select name="packing" v-model="item.line_color">
                                            <option v-for="color in $constant.lineColor" :value="color" :key="color">{{ color }}</option>
                                        </select>
                                    </f7-list-item>

                                    <!-- cover -->
                                    <!-- <f7-list-item :title="$ml.get('cover') + ' (Kg)'" smart-select :smart-select-params="{openIn: 'sheet'}">
                                        <select name="cover_id_1" v-model="item.cover_id_1">
                                            <option v-for="cover in item.covers" :value="cover.id" :key="cover.id">{{ cover.name }} ({{ $helper.numFormat(cover.remaining_amount) }})</option>
                                        </select>
                                    </f7-list-item> -->

                                    <!-- cover cardboard -->
                                    <!-- <f7-list-item :title="$ml.get('coverCardBoard') + ' (Kg)'" smart-select :smart-select-params="{openIn: 'sheet'}">
                                        <select name="cover_id_2" v-model="item.cover_id_2">
                                            <option v-for="cover in item.coversCardboard" :value="cover.id" :key="cover.id">{{ cover.name }} ({{ $helper.numFormat(cover.remaining_amount) }})</option>
                                        </select>
                                    </f7-list-item> -->

                                    <!-- containers -->
                                    <f7-list-item :title="$ml.get('containers')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}" v-if="activeSo && activeSo.status != $constant.so.status.proceed">
                                        <select name="container_id" multiple v-model="item.container_id">
                                            <optgroup v-for="type in item.containers" :key="type.id" :label="type.name">
                                                <option v-for="container in type.containers" :key="container.id" :value="container.id">{{ container.inventory.code }}: {{ container.name }} ({{ container.material.name }}: {{ $helper.numFormat(container.capacity) }})</option>
                                            </optgroup>
                                        </select>
                                    </f7-list-item>

                                    <f7-list-item :title="$ml.get('transferTo')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}" v-if="activeSo && activeSo.status != $constant.so.status.proceed && activeSo.for_internal">
                                        <select name="to_container_id" multiple v-model="item.to_container_id">
                                            <optgroup v-for="(type, index1) in item.toContainers" :key="index1" :label="type.name">
                                                <option v-for="(container, index2) in type.containers" :key="index2" :value="container.id">{{ container.inventory.code }}: {{ container.name }} ({{ $ml.get('space') }}: {{ $helper.numFormat(container.max_capacity - container.capacity) }})</option>
                                            </optgroup>
                                        </select>
                                    </f7-list-item>

                                    <span :set="solo = getSoLo(item.container_id, item.containers)"></span>
                                    <f7-list-item class="multiline" v-if="solo" :title="solo"></f7-list-item>
                                </f7-list>
                            </div>

                            <!-- ACTION BUTTON -->
                            <f7-block>
                                <f7-row>
                                    <f7-col>
                                        <f7-button round fill @click="addMoreDetail">
                                            <i class="f7-icons">add</i>
                                        </f7-button>
                                    </f7-col>
                                    <f7-col>
                                        <f7-button round fill @click="submitSoDetail">
                                            <i class="f7-icons" style="font-size: 24px; line-height: inherit">save</i>
                                        </f7-button>
                                    </f7-col>
                                </f7-row>
                            </f7-block>
                        </f7-page>
                    </f7-view>
                </f7-popup>
                <!-- END POPUP -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'
    import env      from '../../env'

    export default {
        name: 'FromAddSO',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                formSo: {
                    notes: '',
                    vehicle: '',
                    export_reason: '',
                    recipient_name: '',
                    samecont: '',
                    estimated_at: '',
                    company_name: '',
                    shipping_unit: '',
                    customer_id: null,
                    is_exception: false,
                    for_internal: false,
                    documents: null,
                    vat: 0,
                },
                files: null,
                activeSo: null,
                popupOpened: false,
                listSos:   [],
                packings:  [],
                customers: [],
                materials: [],
                sodetails: [],
                defaultCovers: [],
                defaultCoverCardboard: [],
                sosAvailable: [],
            }
        },
        methods: {
            fileChange(fileList) {
                this.files = fileList
                this.form.documents = '$files'
            },

            closePopup() {
                this.activeSo = null
                this.sodetails = []
                this.popupOpened = false
                this.$helper.clearAll()
            },

            addMoreDetail() {
                this.sodetails.push({
                    'amount': null,
                    'material_id': null,
                    'last_material_id': null,
                    'packing': null,
                    'price': null,
                    'line_color': '',
                    'container_id': [],
                    'to_container_id': [],
                    'containers': [],
                    'toContainers': [],
                    'covers': [],
                    'coversCardboard': [],
                    'editable': true,
                    'cover_id_1': null,
                    'cover_id_2': null,
                })
            },

            getSoLo(ids, containers) {
                let suppliers = []
                ids.forEach((id) => {
                    containers.forEach((type) => {
                        type.containers.forEach((container) => {
                            if (id == container.id) {
                                if (container.mocode)
                                    suppliers.push(container.mocode)
                                if (container.suppliers)
                                    suppliers.push(container.suppliers)
                            }
                        })
                    })
                })

                return suppliers.join(', ').trim()
            },

            async onSort() {
                if (this.listSos.length <= 0) return false
                let items = document.querySelectorAll('.list_sos')
                let array = []

                if (items && items.length > 0) {
                    items.forEach((item, index) => {
                        array.push({
                            'id': item.id,
                            'order': index,
                        })
                    })
                }

                await Mutation.reorderSos(this.$helper.toString(array)).execute()
                location.reload()
            },

            async changeMaterial(index, material_id) {
                let detail = this.sodetails[index]
                if (detail && detail.editable && Number(detail.last_material_id) !== Number(material_id)) {
                    this.$set(detail, 'last_material_id', material_id)
                    this.$set(detail, 'packing', null)
                    this.$nextTick(() => this.refreshPackingLabel(index))
                }

                let isCurrentMaterial = () => {
                    let row = this.sodetails[index]
                    return row && Number(row.material_id) === Number(material_id)
                }

                let data1 = await Query.withContainersByType({'material_id': material_id, 'strict': true}).get()
                let data2 = await Query.withContainersByType({'material_id': material_id, 'strict': null}).get()
                if (! isCurrentMaterial()) return
                this.sodetails[index].containers = this.$helper.data(data1, 'container_by_type')
                this.sodetails[index].toContainers = this.$helper.data(data2, 'container_by_type')
                await this.refreshCover(index, material_id)
                if (! isCurrentMaterial()) return
                this.autoSelectPackingForCMOnly(index, material_id)
                await this.refreshCoverCardboard(index, material_id)
            },

            autoSelectPackingForCMOnly(index, material_id) {
                let detail = this.sodetails[index]
                if (! detail || ! detail.editable) return
                if (detail.packing !== null && detail.packing !== '' && detail.packing !== undefined) return

                let material = this.materials.find((item) => Number(item.id) === Number(material_id))
                if (! material) return

                let normalized = `${material.code || ''}${material.name || ''}`.toUpperCase().replace(/\s+/g, '')
                let targetValue = null

                if (/(T?CM25)(?!\d)|25KG(?!\d)/.test(normalized)) targetValue = 25
                else if (/(T?CM10)(?!\d)|10KG(?!\d)/.test(normalized)) targetValue = 10
                else if (/(T?CM5)(?!\d)|5KG(?!\d)/.test(normalized)) targetValue = 5

                if (! targetValue) return

                let candidates = this.packings.filter((packing) => Number(packing.value) === targetValue)
                if (candidates.length <= 0) return

                let selected = candidates.find((packing) => /\bKG\b/i.test(String(packing.name || ''))) || candidates[0]
                this.$set(detail, 'packing', selected.id)
                this.$nextTick(() => this.refreshPackingLabel(index))
            },

            refreshPackingLabel(index) {
                let select = this.$refs['packing_select_' + index]
                if (Array.isArray(select)) select = select[0]
                if (select) {
                    select.dispatchEvent(new Event('change', {bubbles: true}))
                }
            },

            async refreshCover(index, material_id) {
                let data = await Query.withCovers(material_id, 1).get()
                if (! this.sodetails[index] || Number(this.sodetails[index].material_id) !== Number(material_id)) return
                this.sodetails[index].covers = this.$helper.data(data, 'covers')
            },

            async refreshCoverCardboard(index, material_id) {
                let data = await Query.withCovers(material_id, 2).get()
                if (! this.sodetails[index] || Number(this.sodetails[index].material_id) !== Number(material_id)) return
                this.sodetails[index].coversCardboard = this.$helper.data(data, 'covers')
            },

            async downloadSo() {
                if (! this.activeSo) return false;

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let path = this.$helper.data(
                    await Query.exportSo(this.activeSo.id).get(),
                    'export_so'
                )
                this.$f7.dialog.close()
                window.location = env.serverURL + '/export-sale-orders?token=' + this.$helper.userToken() + '&path=' + path
            },

            async refresh() {
                this.$f7 && this.$f7.dialog.preloader(this.$ml.get('processing'))
                /*let formData = await Query
                    .withCustomers()
                    .withPackings()
                    .withMaterials()
                    .withSosAvailable()
                    .withSos()
                    .get()*/

                this.listSos   = this.$helper.data(await Query.withSos().get(), 'sos')
                this.customers = this.$helper.data(await Query.withCustomers().get(), 'customers')
                this.materials = this.$helper.data(await Query.withMaterials().get(), 'materials')
                this.packings  = this.$helper.data(await Query.withPackings().get(), 'packings')
                this.sosAvailable = this.$helper.data(await Query.withSosAvailable().get(), 'sos_available')
                this.$f7 && this.$f7.dialog.close()
            },

            async showPopup(so) {
                this.activeSo = so
                this.popupOpened = true

                let sodetail = this.$helper.data(await Query.withSoDetails(so.id).get(), 'so_details')
                if (sodetail.length > 0) {
                    this.sodetails = []
                    sodetail.forEach((item) => {
                        this.sodetails.push({
                            'amount': item.amount,
                            'material_id': item.material_id,
                            'packing': item.packing,
                            'price': item.price,
                            'line_color': item.line_color,
                            'container_id': item.container_id || [],
                            'to_container_id': item.to_container_id || [],
                            'containername': item.containername,
                            'containers': [],
                            'covers': this.defaultCovers,
                            'coversCardboard': this.defaultCoverCardboard,
                            'editable': false,
                            'cover_id_1': item.cover_id_1,
                            'cover_id_2': item.cover_id_2,
                        })
                    })
                }
            },

            async addCustomer() {
                this.$f7.dialog.prompt(
                    this.$ml.get('inputCustomerName'),
                    this.$ml.get('addCustomer'),
                    async (value) => {
                        this.$f7.dialog.preloader(this.$ml.get('processing'))
                        let result = await Mutation.addCustomer(value).execute()
                        if (result.data.errors) {
                            this.$f7.dialog.close()
                            let message = this.$helper.errors(result.data.errors)
                            return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                        }

                        let formData = await Query.withCustomers().get()
                        this.customers = this.$helper.data(formData, 'customers')
                        this.$f7.dialog.close()

                        return this.$f7.dialog.alert(this.$ml.get('success.addCustomer'), this.$ml.get('information'))
                    },
                )
            },

            async resetFormSo() {
                this.formSo = {
                    notes: '',
                    vehicle: '',
                    export_reason: '',
                    recipient_name: '',
                    samecont: '',
                    estimated_at: '',
                    company_name: '',
                    shipping_unit: '',
                    customer_id: null,
                    is_exception: false,
                    for_internal: false,
                    documents: null,
                    vat: 0,
                }
                this.files = null
                this.$refs.fileupload.value = null
                this.$helper.clearAll()
                this.listSos = this.$helper.data(await Query.withSos().get(), 'sos')
            },

            async resetFormSoDetail() {
                this.activeSo = null
                this.popupOpened = false
                this.listSos = this.$helper.data(await Query.withSos().get(), 'sos')
                this.sodetails = []
            },

            async submitSo() {
                if (! this.formSo.customer_id ||
                    ! this.formSo.estimated_at ||
                    ! this.formSo.is_exception)
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))

                this.formSo.is_exception = this.formSo.is_exception > 0 ? true : false
                let result = await Mutation
                    .addFiles(this.files)
                    .addSO(this.formSo)
                    .execute()

                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.addSO'),
                    this.$ml.get('information'),
                    async () => await this.resetFormSo()
                )
            },

            async submitSoDetail() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                let isValidNumber = true
                this.sodetails.forEach((item) => {
                    if (item.amount <= 0) {
                        isValidNumber = false
                    }
                })
                if (! isValidNumber)
                    return this.$f7.dialog.alert(this.$ml.get('errors.greaterZero'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))

                let result = await Mutation.addSODetail({
                    'so_id': this.activeSo.id,
                    'notes': this.activeSo.notes,
                    'vehicle': this.activeSo.vehicle,
                    'export_reason': this.activeSo.export_reason,
                    'recipient_name': this.activeSo.recipient_name,
                    'estimated_at': this.activeSo.estimated_at,
                    'company_name': this.activeSo.company_name,
                    'shipping_unit': this.activeSo.shipping_unit,
                    'samecont': this.activeSo.samecont,
                    'vat': this.activeSo.vat || 0,
                    'data': this.$helper.toString(this.sodetails.map((item) => {
                        return {
                            'amount': item.amount,
                            'packing': item.packing,
                            'price': item.price,
                            'line_color': item.line_color,
                            'material_id': item.material_id,
                            'container_id': item.container_id,
                            'to_container_id': item.to_container_id,
                            'cover_id_1': item.cover_id_1,
                            'cover_id_2': item.cover_id_2,
                        }
                    }))
                }).execute()

                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)
                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.addSODetail'),
                    this.$ml.get('information'),
                    () => this.resetFormSoDetail()
                )
            },
        },

        async created() {
            await this.refresh()
            let data1 = await Query.withCovers(null, 1).get()
            let data2 = await Query.withCovers(null, 2).get()
            this.defaultCovers = this.$helper.data(data1, 'covers')
            this.defaultCoverCardboard = this.$helper.data(data2, 'covers')
        },

        watch: {
            sodetails() {
                this.sodetails.forEach((item, index) => {
                    this.changeMaterial(index, item.material_id)
                })
            },
        },
    }
</script>

<style>
    .multiline .item-title {
        white-space: initial !important;
    }
</style>
